import LabelInput from "components/Base/LabelInput";
import { useEffect, useState } from "react";
import UploadMedia from "components/Base/UploadMedia";
import { alertActions } from "actions/alert.actions";
import useStyles from "./styles";
import { useDispatch } from "react-redux";
import { nextArrowIcon } from "assets/icons";

const Step2 = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    onNextClick,
    onBackClick,
    getValues,
    setValue,
    register,
    errors,
    onHandleCloseModal,
    urlVideoRecipe,
    setUrlVideoRecipe,
    recipeImage,
    setRecipeImage,
    itemEdit,
    setEditRecipe,
    onChangeImage,
    onChangeUrl,
    setIsChangeImage,
  } = props;
  const [urlLink, setUrlLink] = useState<any>("");

  const onChangeBlurUrlVideoRecipe = () => {
    const videoUrl = getValues("urlVideoRecipe");
    videoUrl !== itemEdit?.url && setEditRecipe(true);
    setUrlVideoRecipe(getValues("urlVideoRecipe"));
  };

  const onChangeImageRecipe = (image: any, thumbnailImage: any) => {
    setUrlLink(image);
    setRecipeImage(image);
    onChangeImage(image);
    setIsChangeImage(true);
    setEditRecipe(true);
  };

  const validateStep2 = () => {
    const videoUrl = getValues("urlVideoRecipe");
    if (!urlVideoRecipe && videoUrl === "" && !recipeImage) {
      dispatch(alertActions.error("You must enter image or video!"));
      return;
    }
    if (
      videoUrl !== "" &&
      !videoUrl.includes("https://www.youtube.com") &&
      !videoUrl.includes("https://youtu.be") &&
      !videoUrl.includes("https://vimeo.com")
    ) {
      dispatch(alertActions.error("Only support Youtube or Vimeo Url"));
      return;
    }
    onChangeUrl(videoUrl);
    onNextClick();
  };

  useEffect(() => {
    if (itemEdit) {
      setValue("urlVideoRecipe", itemEdit?.url);
      setUrlVideoRecipe(itemEdit?.url);
      setRecipeImage(itemEdit?.image);
    } else {
      setValue("urlVideoRecipe", urlVideoRecipe);
    }
  }, []);

  useEffect(() => {
    setUrlLink(recipeImage);
  }, [itemEdit, recipeImage]);

  // const renderLinkImages = async () => {
  //   let rs: any = itemEdit?.image || '';
  //   if (recipeImage && !isString(recipeImage)) {
  //     rs = await toBase64(recipeImage) || '';
  //   } else {
  //     rs = recipeImage || ''
  //   }
  //   setUrlLink(rs);
  //   return null;
  // }

  // useEffect(() => {
  //   renderLinkImages();
  // }, [itemEdit, recipeImage]);

  return (
    <>
      <div className={classes.container}>
        <LabelInput
          name="urlVideoRecipe"
          label="YouTube or Vimeo URL"
          onChange={onChangeBlurUrlVideoRecipe}
          customClass={classes.customInput}
          ref={register({
            pattern:
              /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi,
            // validate: (value: any) => value.includes('https://www.youtube.com') || value.includes('https://vimeo.com'),
            required: itemEdit ? itemEdit?.image === "" : !recipeImage,
          })}
        />
        <p
          style={{
            font: "normal normal 700 16px/24px Montserrat",
            marginBottom: -20,
          }}
        >
          OR
        </p>
        <UploadMedia
          label=""
          placeholder={"Drag or Upload Image"}
          customClass={classes.selectAppIcon}
          onChangeImage={onChangeImageRecipe}
          name="recipeImage"
          ref={register({
            required: itemEdit ? !itemEdit?.url : errors?.urlVideoRecipe,
          })}
          mediaUrl={urlLink}
        />
      </div>
      <div className={classes.footerModal}>
        <button className={classes.cancelButton} onClick={onHandleCloseModal}>
          Cancel
        </button>
        <button className={classes.backButton} onClick={onBackClick}>
          Back
        </button>
        <button className={classes.nextButton} onClick={validateStep2}>
          Next
          <div className={classes.nextButtonIconContainer}>
            <img src={nextArrowIcon} alt="Next Button Icon" />
          </div>
        </button>
      </div>
    </>
  );
};

export default Step2;
